module.exports = "https://r.nearpod.com/assets/media/image/AvenirLTStd-Heavy-4e28698425aee001121a32e7d1f2f2bd.svg";